<div class="ds-editor">
  <div class="row padding-xs-vr">
    <div class="col-sm-4" *ngIf="!fixedBrickId">
      <label class="control-label">Brick</label>
      <span class="ui-fluid">
        <p-dropdown [options]="brickOptions" [(ngModel)]="brickId" name="tsBrick" [filter]="true" placeholder="Brick" styleClass="wid100" [disabled]="!!split" (onChange)="rows = []"></p-dropdown>
      </span>
    </div>
    <div class="col-sm-4">
      <label class="control-label">Product</label>
      <span class="ui-fluid">
        <p-dropdown [options]="productOptions" [(ngModel)]="productId" name="tsProduct" [filter]="true" placeholder="Brand or item" styleClass="wid100"></p-dropdown>
      </span>
    </div>
    <div class="col-sm-2">
      <label class="control-label">From</label>
      <input type="text" class="form-control" name="tsStart" [(ngModel)]="start" bsDatepicker [bsConfig]="{dateInputFormat: 'DD/MM/YYYY'}" autocomplete="off" (bsValueChange)="rows = split ? rows : []">
    </div>
    <div class="col-sm-2">
      <label class="control-label">To (optional)</label>
      <input type="text" class="form-control" name="tsEnd" [(ngModel)]="end" bsDatepicker [bsConfig]="{dateInputFormat: 'DD/MM/YYYY'}" autocomplete="off">
    </div>
  </div>
  <div class="row padding-xs-vr">
    <div class="col-sm-4" *ngIf="lines.length > 1 && !fixedLineId">
      <label class="control-label">{{names.line}}</label>
      <select class="form-control" [(ngModel)]="lineId" name="tsLine" (ngModelChange)="fillRows()">
        <option *ngFor="let l of lines" [ngValue]="l.id">{{l.name}}</option>
      </select>
    </div>
    <div class="col-sm-4 margin-top-10">
      <a href="javascript:;" (click)="loadTerritories()"><i class="fa fa-refresh"></i> {{rows.length ? 'Reload' : 'Load'}} {{names.holders | lowercase}}</a>
      <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
    </div>
  </div>
  <table class="table table-condensed ds-table" *ngIf="rows.length">
    <thead><tr><th>{{names.holder}}</th><th class="text-right">Default share %</th><th class="text-right" style="width:160px">Share %</th></tr></thead>
    <tbody>
      <tr *ngFor="let r of rows; let i = index">
        <td>{{r.businessUnitName}}</td>
        <td class="text-right">{{r.defaultPercent == null ? '' : (r.defaultPercent | number:'1.0-2')}}</td>
        <td><input type="number" class="form-control input-sm text-right" [(ngModel)]="r.percent" name="tsPct{{i}}" min="0" max="100" step="0.01"></td>
      </tr>
      <tr><td><b>Total</b></td><td></td><td class="text-right" [class.text-danger]="total < 99.95 || total > 100"><b>{{total | number:'1.0-2'}}</b></td></tr>
    </tbody>
  </table>
  <div class="text-danger" *ngIf="error">{{error}}</div>
  <div class="margin-top-10">
    <button type="button" class="btn btn-cancel" (click)="cancelled.emit()">Cancel</button>&nbsp;
    <button type="button" class="btn btn-save" [disabled]="saving" (click)="save()">Save split</button>
  </div>
</div>
